import src from "IMAGE";
export default { src, width: 236, height: 59, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAN0lEQVR42m3DMQoAIAgAQB9QU58IAgfHqKbo083RF6Jd8Rl+wOFA71A+XTx/1werpUklkgdzQAOsfhtccObsTAAAAABJRU5ErkJggg=="};
